<template>
    <div v-if="document">
        <rich-text-renderer role="presentation" :document="document" :nodeRenderers="renderNode" />
    </div>
</template>

<script>
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import CtfRichTextEmbedEntry from './ctf-rich-text-embed-entry'
import RichTextRenderer from 'contentful-rich-text-vue-renderer'

export default {
  name: 'CtfRichText',
  components: {
    RichTextRenderer
  },
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      renderNode: {
        [INLINES.ASSET_HYPERLINK]: (node, key, h) => {
          return h('ctf-rich-text-asset-link', {
            key: key,
            props: { sysId: node.data.target.sys.id, text: documentToHtmlString(node) }
          })
        },
        [INLINES.ENTRY_HYPERLINK]: (node, key, h) => {
          return h('ctf-rich-text-link', {
            key: key,
            props: { sysId: node.data.target.sys.id, text: documentToHtmlString(node) }
          })
        },
        [BLOCKS.EMBEDDED_ENTRY]: (node, key, h) => {
          return h(CtfRichTextEmbedEntry, {
            key: key,
            props: { sysId: node.data.target.sys.id }
          })
        },
        [BLOCKS.EMBEDDED_ASSET]: (node, key, h) => {
          return h('ctf-rich-text-embed-asset', {
            key: key,
            props: { sysId: node.data.target.sys.id }
          })
        },
        [INLINES.HYPERLINK]: (node, key, h) => {
          return h('ctf-rich-text-external-link', {
            key: key,
            props: { uri: node.data.uri, text: documentToHtmlString(node) }
          })
        }
      }
    }
  },
  mounted () {
    // setTimeout(() => {
    //   const headers = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
    //   headers.forEach(header => {
    //     this.$el.querySelectorAll(header).forEach(el => {
    //       el.setAttribute('role', 'presentation')
    //     })
    //   })
    // }, 2000)
  }
}
</script>

<style lang="scss" scoped>
div {
  overflow-wrap: break-word;
}
</style>
